/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./search-input.vue?vue&type=template&id=0b8e4637&scoped=true&"
import script from "./search-input.vue?vue&type=script&lang=ts&"
export * from "./search-input.vue?vue&type=script&lang=ts&"
import style0 from "./search-input.vue?vue&type=style&index=0&id=0b8e4637&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b8e4637",
  null
  
)

export default component.exports